import { applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'

export const sagaMiddleware = createSagaMiddleware()

export default (initial = []) => {
  const middlewares = initial

  middlewares.push(sagaMiddleware)

  if (process.browser && process.env.NODE_ENV === 'development') {
    middlewares.push(
      createLogger({
        collapsed: true,
        stateTransformer: state => state.toJS(),
      }),
    )
  }

  return applyMiddleware(...middlewares)
}



// WEBPACK FOOTER //
// ../source/state/middleware.js